import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from 'vant'
import zhCN from 'vant/es/locale/lang/zh-CN'
import enUS from 'vant/es/locale/lang/en-US'
import jaJP from 'vant/es/locale/lang/ja-JP'
import thTH from 'vant/es/locale/lang/th-TH'
import deDE from 'vant/es/locale/lang/de-DE'
import frFR from 'vant/es/locale/lang/fr-FR'
import esES from 'vant/es/locale/lang/es-ES'
import zhCn from './zh-cn'
import enUs from './en-us'
import jaJp from './ja-jp'
import koKr from './ko-kr'
import thTh from './th-th'
import deDe from './de-de'
import frFr from './fr-fr'
import esEs from './es-es'
import itIt from './it-it'
import ptPt from './pt-pt'
import ruRu from './ru-ru'
import nlNl from './nl-nl'
import plPl from './pl-pl'

Vue.use(VueI18n)

export const DEFAULT_LANGUAGE = 'en-us'

export const LANGUAGES = [
  { code: 'en-us', name: 'English', flagCode: 'gb' },
  { code: 'ja-jp', name: '日本語', flagCode: 'jp' },
  { code: 'ko-kr', name: '한국어', flagCode: 'kr' },
  { code: 'th-th', name: 'ภาษาไทย', flagCode: 'th' },
  { code: 'de-de', name: 'Deutsch', flagCode: 'de' },
  { code: 'fr-fr', name: 'Français', flagCode: 'fr' },
  { code: 'es-es', name: 'Español', flagCode: 'es' },
  { code: 'it-it', name: 'Italiano', flagCode: 'it' },
  { code: 'pt-pt', name: 'Português', flagCode: 'pt' },
  { code: 'ru-ru', name: 'Русский', flagCode: 'ru' },
  { code: 'nl-nl', name: 'Nederlands', flagCode: 'nl' },
  { code: 'pl-pl', name: 'Polski', flagCode: 'pl' },
]

const vantLocales = {
  'zh-cn': { name: 'zh-CN', messages: zhCN },
  'en-us': { name: 'en-US', messages: enUS },
  'ja-jp': { name: 'ja-JP', messages: jaJP },
  'th-th': { name: 'th-TH', messages: thTH },
  'de-de': { name: 'de-DE', messages: deDE },
  'fr-fr': { name: 'fr-FR', messages: frFR },
  'es-es': { name: 'es-ES', messages: esES },
  'ko-kr': { name: 'en-US', messages: enUS },
  'it-it': { name: 'en-US', messages: enUS },
  'pt-pt': { name: 'en-US', messages: enUS },
  'ru-ru': { name: 'en-US', messages: enUS },
  'nl-nl': { name: 'en-US', messages: enUS },
  'pl-pl': { name: 'en-US', messages: enUS },
}

const messages = {
  'zh-cn': zhCn,
  'en-us': enUs,
  'ja-jp': jaJp,
  'ko-kr': koKr,
  'th-th': thTh,
  'de-de': deDe,
  'fr-fr': frFr,
  'es-es': esEs,
  'it-it': itIt,
  'pt-pt': ptPt,
  'ru-ru': ruRu,
  'nl-nl': nlNl,
  'pl-pl': plPl,
}

if (!localStorage.getItem('language')) {
  localStorage.setItem('language', DEFAULT_LANGUAGE)
}

const savedLanguage = localStorage.getItem('language') || DEFAULT_LANGUAGE

const i18n = new VueI18n({
  locale: savedLanguage,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages,
})

function applyVantLocale(code) {
  const locale = vantLocales[code] || vantLocales[DEFAULT_LANGUAGE]
  Locale.use(locale.name, locale.messages)
}

applyVantLocale(savedLanguage)

export function setLanguage(code) {
  if (!messages[code]) return
  i18n.locale = code
  localStorage.setItem('language', code)
  applyVantLocale(code)
}

export default i18n
